import { createCRUDHook } from './createCRUDHook';
import { PartAssemblyBrushTypeDto } from 'utils/models';
import { TBL_PART_ASSEMBLY_BRUSH_TYPE } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<PartAssemblyBrushTypeDto>({
    entityName: 'PartAssemblyBrushType',
    endpoint: TBL_PART_ASSEMBLY_BRUSH_TYPE,
  });

export const PartAssemblyBrushTypeContext = Context;
export const usePartAssemblyBrushTypeManager = useManager;
export const usePartAssemblyBrushType = useConsumer;
